// src/components/blog/BlogPostPreviewCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { slugify } from '../../utils/helpers'; // <<< NOUVEL IMPORT (ajuste le chemin si besoin)
import './BlogPostPreviewCard.css';

function BlogPostPreviewCard({ post }) {
  if (!post) {
    return null;
  }

  const formattedDate = new Date(post.date).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <article className="blog-post-preview-card">
      {post.imageUrl && (
        <Link to={`/blog/${post.slug}`} className="card-image-link" aria-label={`Lire l'article : ${post.title}`}>
          <img src={post.imageUrl} alt={`Image d'illustration pour ${post.title}`} />
        </Link>
      )}
      <div className="card-content">
        <h2>
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h2>
        <p className="post-meta-preview">
          Publié le {formattedDate}
          {post.author && <span className="author"> par {post.author}</span>}
        </p>
        {post.excerpt && <p className="post-excerpt-preview">{post.excerpt}</p>}
        
        {post.tags && post.tags.length > 0 && (
          <div className="card-tags-container">
            {post.tags.map(tag => (
              // MODIFIÉ : Le span devient un Link
              <Link key={tag} to={`/blog/tag/${slugify(tag)}`} className="tag-item">
                {tag}
              </Link>
            ))}
          </div>
        )}

        <Link 
          to={`/blog/${post.slug}`} 
          className="read-more-link" 
        >
          Lire la suite &rarr;
        </Link>
      </div>
    </article>
  );
}

export default BlogPostPreviewCard;